import { useMemo } from "react";
import { useProductAssignments } from "../../../hooks/useProductAssignments";
import {
  BannerContent,
  BannerDescription,
  BannerIconWrapper,
  BannerTitle,
  BannerWrapper,
} from "./UnassignedProductsBanner.styles";
import { Button, Icon } from "@gds-react/core";
import { AddOutlined } from "@gds-react/icons";
import { useTranslation } from "react-i18next";
import { Product } from "../../../generated-api/marketplace";

interface Props {
  accountId?: string;
  onSetupConnector: () => void;
}

export default function UnassignedProductsBanner({
  accountId,
  onSetupConnector,
}: Props) {
  const { t } = useTranslation();
  const { data } = useProductAssignments(accountId);

  const unassignedProducts = useMemo(() => {
    if (!data) return [];
    return data.filter((item) => !item.deviceId);
  }, [data]);

  if (unassignedProducts.length === 0) return null;

  const productNames = unassignedProducts
    .map((item) => (item.product as Product)?.name || "Unknown Product")
    .filter((name, index, self) => self.indexOf(name) === index);

  return (
    <BannerWrapper>
      <BannerIconWrapper>
        <Icon src={<AddOutlined />} />
      </BannerIconWrapper>
      <BannerContent>
        <BannerTitle>
          {t("devicePage.unassignedProducts.title", {
            count: unassignedProducts.length,
          })}
        </BannerTitle>
        <BannerDescription>
          {t("devicePage.unassignedProducts.description", {
            products: productNames.join(", "),
          })}
        </BannerDescription>
      </BannerContent>
      <Button onClick={onSetupConnector}>
        {t("devicePage.unassignedProducts.setupButton")}
      </Button>
    </BannerWrapper>
  );
}
